import { trackDeleteMessageSuccess } from './tracking';
import { setDeleteMessage, setSendMessageSuccess } from '../../actions/sendMessage';
import { currentChatOpponentIdSelector } from '../../selectors';
import { performDeleteMessage } from '../../services/performDeleteMessage';
import { showAlert } from '../../slices/alertSlice';
import { closeDeleteMessageModal, markMessageAsDeleted, TDeletePlaceType } from '../../slices/deleteMessageSlice';
import { createAppAsyncThunk } from '../../store/createAppAsyncThunk';
import { EAlert } from '../../types/alert';

export interface IDeleteMessageParameters {
  chatId: string;
  messageId: string;
  type: TDeletePlaceType;
}

const DELETE_MESSAGE_FAIL = 'deleteMessage.fail';
const DELETE_MESSAGE_SUCCESS = 'deleteMessage.success';

export const deleteMessage = createAppAsyncThunk(
  'messages/deleteMessage',
  async ({ messageId, chatId }: IDeleteMessageParameters, { getState, dispatch, extra: context }) => {
    const {
      logger,
      telemetry,
      custom: { messagesMap },
    } = context;

    const messageItem = messagesMap.get(messageId);

    if (!messageItem) {
      logger.error(new Error('Сообщение для удаления не найдено'), {
        domain: 'src/shared/thunks/deleteMessage.ts',
        message: 'Сообщение не удалено',
      });

      return;
    }

    const { rawMessage } = messageItem.message;

    dispatch(markMessageAsDeleted());
    dispatch(closeDeleteMessageModal());
    dispatch(setDeleteMessage({ chatId, messageId, messagesMap }));

    const isDeleted = await performDeleteMessage(context, { parameters: { chatId, messageId } });

    if (!isDeleted) {
      dispatch(showAlert({ message: 'Не удалось удалить сообщение' }));
      dispatch(setSendMessageSuccess({ message: rawMessage, messageId, messagesMap }));
      telemetry.increment(DELETE_MESSAGE_FAIL);

      return;
    }

    const opponentId = currentChatOpponentIdSelector(getState());
    const withPhoto = Boolean(
      rawMessage.files && (rawMessage.files.images.length || rawMessage.files.documents?.length),
    );

    telemetry.increment(DELETE_MESSAGE_SUCCESS);
    trackDeleteMessageSuccess({ chatId, withPhoto, opponentId });
    dispatch(showAlert({ type: EAlert.Info, message: 'Сообщение удалено у всех' }));
  },
);
